// extracted by mini-css-extract-plugin
export default {"preloader":"Preloader_preloader__bgS7w","hide":"Preloader_hide__4j1cY"};